import { notifyError } from "../../Notify/notify";

export const onError = (err: Record<string, string[]>) => {
  let errorMessage = "Something went wrong!";
  if (typeof err === "object") {
    for (const key in err) {
      if (err[key] && Array.isArray(err[key])) {
        errorMessage = err[key][0];
      }
    }
  }
  notifyError(errorMessage);
};
